import { Component, Inject, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobService } from 'src/app/core/services/job.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GenericService } from 'src/app/core/services/generic.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { CandidatesContainer } from './candidates-container';
import { CandidatesQueryFilter } from 'src/app/core/models/candidates-query-filter';
import { CandidateDisplayQueryFilter } from 'src/app/core/models/candidate-display-query-filter';
import { DisplayOnMultiSelectPipe } from 'src/app/core/pipes/display-on-multi-select.pipe';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';

declare var $: any;

@Component({
  selector: 'app-candidates-page',
  templateUrl: './candidates-page.component.html',
  styleUrls: ['./candidates-page.component.css'],
  providers: [DisplayOnMultiSelectPipe]
})
export class CandidatesPageComponent implements OnInit {

  @Input() $transition$: any;

  $stateParams: any;
  candidates!: any[];
  salaryDurationOptions!: any[];
  filterSalaryDurationOptions!: any[];
  filterRateDurationOptions!: any[];
  selectedJobMatchStates!: any[];
  jobMatchStates!: any[];
  candidatesCount!: number;
  candidatesContainer: any;
  userId: any;
  infoOfCandidateInContext: any;
  companyType: any;
  clientOrBuList: any;
  candidateStatusList: any;
  requisitionStatusList: any;
  recruitersList!: any[];
  vendors!: any[];
  requisitionNumbersList: any;
  candidateInfoContainerId: any;
  selectedDateRange!: string;
  activityMap!: any[];
  jobMatchesPopoverIsOpen: any;
  divident!: number;
  activeTabIndex!: number;
  showFiltersPanel!: boolean;
  isFiltersChanged!: boolean;
  savedFilters: any;
  visibilityFilters: any;
  sortByFilters!: any[];
  selectedSort!: string;
  selectedSortDirection!: string;
  selectedClientOrBuList!: any[];
  selectedRequisitionStatusList!: any[];
  selectedRecruitersList!: any[];
  selectedVendors!: any[];
  selectedRequisitionNumbersList!: any[];
  candidateFilterItemsSelected!: any[];
  selectedPreferredJobTypeAdditionalList!: any[];
  candidateJobMatchActiveTab: any;
  isVendorCompany!: boolean;
  hideSearchStringFlag!: boolean;
  candidatesExistFlag!: boolean;
  showCandidateInfo!: boolean;
  loadingClientsOrBusFilter!: boolean;
  loadingCandidateStatusesFilter!: boolean;
  loadingRequisitionStatusesFilter!: boolean;
  loadingRequisitionNumbersFilter!: boolean;
  loadingJobMatchStatesFilter!: boolean;
  loadingVendorsFilter!: boolean;
  loadingRecruitersFilter!: boolean;
  loadingWorkLocationsFilter!: boolean;
  emptyCandidateSelectedFilter!: boolean;
  loadingPreferredJobTypeFilter!: boolean;
  loadingWorkAuthorizationFilter!: boolean;
  loadingAdditionalPreferredJobTypeFilter!: boolean;
  isDisplayRateFilterActive!: boolean;
  userName!: string;
  defaultFilters: any;
  displayCandidateSelectedFilter: any;
  savedDisplayedCandidateSelectedFilter: any;
  showCandidateDisplaySelectedFilterPanel: any;
  isRowViewActive!: boolean;
  currentCandidatePage!: number;
  private lastFetchedCandidatePage!: number;
  currentRequisitionPage: any;
  workLocationList: any;
  selectedWorkLocationList!: any[];
  selectedCandidateStatusList!: any[];
  preferredJobTypeList: any;
  selectedPreferredJobTypeList!: any[];
  preferredJobTypeAdditionalList: any;
  workAuthorizationList: any;
  selectedWorkAuthorizationList!: any[];
  currencyCodes: any;
  displayCandidateFilterFlag: any;
  displaySelectedFilterObj: any;
  deleteSelectedFilter: any;
  isPreferredJobTypeNotFullTime = false;

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  constructor(
    private storageService: StorageService,
    private genericService: GenericService,
    private jobService: JobService,
    private candidateService: CandidateService,
    private jobMatchService: JobMatchService,
    private companyService: CompanyService,
    private userRoleService: UserRoleService,
    private stateManagementStorageService: StateManagementStorageService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private authService: AuthService,
    private displayOnMultiSelectPipe: DisplayOnMultiSelectPipe,
    @Inject(SharedAjsService) private sharedAjsService: SharedAjsService,
    public $state: StateService
  ) { }

  ngOnInit() {
    this.$stateParams = this.$transition$.params();
    this.candidates = [];
    this.salaryDurationOptions = [];
    this.filterSalaryDurationOptions = [];
    this.filterRateDurationOptions = [];
    this.selectedJobMatchStates = [];
    this.jobMatchStates = [];
    this.candidatesCount = 0;
    this.candidatesContainer = null;
    this.userId = null;
    this.infoOfCandidateInContext = null;
    this.companyType = null;
    this.clientOrBuList = null;
    this.candidateStatusList = null;
    this.requisitionStatusList = null;
    this.recruitersList = [];
    this.vendors = [];
    this.requisitionNumbersList = null;
    this.candidateInfoContainerId = null;
    this.selectedDateRange = '';
    this.activityMap = [];
    this.divident = 4;
    this.activeTabIndex = 1;
    this.showFiltersPanel = false;
    this.isFiltersChanged = false;
    this.savedFilters = null;
    this.visibilityFilters = {
      unassigned: '',
      assignedToMe: '',
      assignedToOthers: ''
    };
    this.sortByFilters = [
      { column: 'status', columnDisplayName: 'Candidate Status' },
      { column: 'createdDate', columnDisplayName: 'Creation Date' },
      { column: 'email', columnDisplayName: 'Email' },
      { column: 'firstName', columnDisplayName: 'First Name' },
      { column: 'lastName', columnDisplayName: 'Last Name' },
      { column: 'updatedDate', columnDisplayName: 'Most Recently Updated' },
      { column: 'phone', columnDisplayName: 'Phone' },
      { column: 'recruiterList', columnDisplayName: 'Recruiters' },
      { column: 'requisitionNumbers', columnDisplayName: 'Requisition Number' },
      { column: 'requisitionStatus', columnDisplayName: 'Requisition Status' }
    ];
    this.selectedSort = 'Please Select';
    this.selectedSortDirection = '';
    this.selectedClientOrBuList = [];
    this.selectedRequisitionStatusList = [];
    this.selectedRecruitersList = [];
    this.selectedVendors = [];
    this.selectedRequisitionNumbersList = [];
    this.candidateFilterItemsSelected = [];
    this.selectedPreferredJobTypeAdditionalList = [];
    this.candidateJobMatchActiveTab = {};
    this.isVendorCompany = false;
    this.hideSearchStringFlag = false;
    this.candidatesExistFlag = true;
    this.showCandidateInfo = false;
    this.loadingClientsOrBusFilter = true;
    this.loadingCandidateStatusesFilter = true;
    this.loadingRequisitionStatusesFilter = true;
    this.loadingRequisitionNumbersFilter = true;
    this.loadingJobMatchStatesFilter = true;
    this.loadingVendorsFilter = true;
    this.loadingRecruitersFilter = true;
    this.loadingWorkLocationsFilter = true;
    this.emptyCandidateSelectedFilter = false;
    this.loadingPreferredJobTypeFilter = true;
    this.loadingWorkAuthorizationFilter = true;
    this.loadingAdditionalPreferredJobTypeFilter = true;
    this.isDisplayRateFilterActive = false;
    this.workLocationList = null;
    this.selectedWorkLocationList = [];
    this.selectedCandidateStatusList = [];
    this.preferredJobTypeList = null;
    this.selectedPreferredJobTypeList = [];
    this.preferredJobTypeAdditionalList = null;
    this.workAuthorizationList = null;
    this.selectedWorkAuthorizationList = [];
    this.currencyCodes = null;

    this.queryCandidates = _.debounce(this.queryCandidates.bind(this), 900);

    this.init();
    this._handleFilterDisplay();
  }

  init(): void {
    if (window.innerWidth < 1400) {
      this.divident = 3;
    }
    this.isVendorCompany = this.companyService.isCompanyVendor();
    this.candidates = [];
    this.candidatesContainer = new CandidatesContainer(this.authService, this.divident, this.candidateService, this.alertsAndNotificationsService);
    const userDetails = this.authService.getUserDetails();
    this.userId = userDetails.id;
    this.userName = userDetails.firstname + ' ' + userDetails.lastname;
    this.companyType = userDetails.company.companyType;
    if (this.companyType === 'StaffingCompany') {
      const clientOrBu = { column: 'clientOrBuList', columnDisplayName: 'Client' };
      this.sortByFilters.splice(1, 0, clientOrBu);
    } else {
      const clientOrBu = { column: 'clientOrBuList', columnDisplayName: 'BU' };
      this.sortByFilters.splice(0, 0, clientOrBu);
    }
    // Remove candidate screen on company switch (in super user)
    this._checkAndRemoveIfFilterExistsWithCompanyId();

    const savedFilters = this.stateManagementStorageService.getScreenState(`candidatesScreen-${this.userId}`);
    this.defaultFilters = new CandidatesQueryFilter(userDetails.company.companyId, userDetails.id);
    if (savedFilters && this.$stateParams.searchString == null
      && this.$stateParams.candidateStatuses == null
      && this.$stateParams.recruiters == null
      && this.$stateParams.visibilityFilters == null
      && this.$stateParams.searchString == null
      && this.$stateParams.candidateType == null
      && this._checkIfNewFiltersAdded(this.defaultFilters, savedFilters)) {
      this.candidatesContainer.candidatesQueryFilter = _.cloneDeep(savedFilters);
      this.savedFilters = _.cloneDeep(savedFilters);
    } else {
      this._setSalaryAndRate();
      this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.defaultFilters);
    }

    // Display Selected Filters
    this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
    const savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
    if (savedDisplayedCandidateSelectedFilter && this._checkIfNewFiltersAdded(this.displayCandidateSelectedFilter, savedDisplayedCandidateSelectedFilter)) {
      if (this.$stateParams.candidateStatuses) {
        savedDisplayedCandidateSelectedFilter.searchString = '';
        this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, savedDisplayedCandidateSelectedFilter);
      }
      this.displayCandidateSelectedFilter = _.cloneDeep(savedDisplayedCandidateSelectedFilter);
      this.savedDisplayedCandidateSelectedFilter = _.cloneDeep(savedDisplayedCandidateSelectedFilter);
      if (this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon === undefined) {
        this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
      }
    } else {
      this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
      this.savedDisplayedCandidateSelectedFilter = _.cloneDeep(this.displayCandidateSelectedFilter);
    }
    this.showCandidateDisplaySelectedFilterPanel = this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;

    this._setStateParamsFilter();

    this._setCandidatesSortFilter();
    // get all the filter data
    this.getAllClientsOrBu(() => {
      this.getAllRequisitionNumbers(() => {
        this.getAllRecruiters(() => {
          // check if any state params are present and add them onto the filters
          if (this.$stateParams.recruiters !== null && Array.isArray(this.$stateParams.recruiters)) {
            this.candidatesContainer.candidatesQueryFilter.recruiterList = this.$stateParams.recruiters;
            this._setFilterValues('Recruiters', this.$stateParams.recruiters);
          }
          this.getAllRequisitionStatuses(() => {
            this.getAllWorkLocations(() => {
              this.getAllJobMatchStates(() => {
                if (this.companyType === 'Corporation') {
                  this.getAllVendors(() => {
                    this.savedFilters = null;
                  });
                } else {
                  this.loadingVendorsFilter = false;
                  this.savedFilters = null;
                }
              });
            });
          });
        });
      });
    });

    this.getAllCandidateStatuses(() => {
      // check if any state params are present and add them onto the filters
      if (this.$stateParams.candidateStatuses !== null && Array.isArray(this.$stateParams.candidateStatuses)) {
        this.candidatesContainer.candidatesQueryFilter.status = this.$stateParams.candidateStatuses;
        this._setFilterValues('CandidateStatus', this.$stateParams.candidateStatuses);
      }
    });
    this.getAllActivityTypes();
    this.getSalaryDurationOptions();
    this.getAllPreferredJobTypes();
    this.getAllAdditionalPreferredJobTypes();
    this.getAllWorkAuthorizations();
    this.getCurrencyCodes();
    this._setDisplaySalaryAndRateFilter();
    this.isRowViewActive = false;
    this.currentCandidatePage = 1;
    this._setCandidateRowViewStatus();
    if (!this.isRowViewActive) {
      // explicit initial fetch: ngx-infinite-scroll's own auto-fire check can race
      // against layout still settling (filters/candidate cards loading async above),
      // leaving the list empty until the user manually scrolls
      this.candidatesContainer.getNext();
    }
  }

  _setCandidateRowViewStatus(): void {
    const checkIfRowViewActive = this.stateManagementStorageService.getScreenState(`candidatesScreen-rowView-${this.userId}`);
    if (checkIfRowViewActive) {
      this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
      if (this.isRowViewActive) {
        this.lastFetchedCandidatePage = this.currentCandidatePage;
        this.candidatesContainer.getNextPage(this.currentCandidatePage);
      }
    }
  }

  toggleCandidateRowView(): void {
    this.isRowViewActive = !this.isRowViewActive;
    this.stateManagementStorageService.setScreenState(`candidatesScreen-rowView-${this.userId}`, { isRowViewActive: this.isRowViewActive });
    if (this.isRowViewActive) {
      this.closeCandidateInfoRow();
      this.lastFetchedCandidatePage = this.currentCandidatePage;
      this.candidatesContainer.getNextPage(this.currentCandidatePage);
    } else {
      // Reset Candidate card view
      this.candidatesContainer.candidatesExistFlag = true;
      this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
      this.candidatesContainer.candidates = [];
      this.candidatesContainer.disableInfiniteScroll = false;
      // explicit fetch: card view's infinite-scroll auto-fire check can race
      // against layout still settling right after the toggle, leaving the
      // list empty until the user manually scrolls
      this.candidatesContainer.getNext();
    }
  }

  // ngx-bootstrap's <pagination> re-emits pageChanged whenever its [totalItems]
  // input changes (e.g. after candidatesCount is updated by the very API call
  // pageChanged triggered), which without this guard re-fires getNextPage for
  // the same page in an infinite loop.
  onCandidatePageChanged(event: any): void {
    if (!event || event.page === this.lastFetchedCandidatePage) { return; }
    this.lastFetchedCandidatePage = event.page;
    this.currentCandidatePage = event.page;
    this.candidatesContainer.getNextPage(event.page);
  }

  _checkIfNewFiltersAdded(defaultFilters: any, savedFilters: any): boolean {
    return Object.keys(defaultFilters).every(filter => Object.keys(savedFilters).includes(filter));
  }

  _checkAndRemoveIfFilterExistsWithCompanyId(): void {
    const existingCandidateScreenState = this.stateManagementStorageService.getScreenState(`candidatesScreen-${this.userId}`);
    if (existingCandidateScreenState) {
      if (existingCandidateScreenState.parentCompanyId !== this.authService.getUserDetails().company.companyId) {
        this.stateManagementStorageService.clearStateScreen(`candidatesScreen-${this.userId}`);
        this.stateManagementStorageService.clearStateScreen(`candidatesScreen-displayFilter-${this.userId}`);
      }
    }
  }

  _setStateParamsFilter(): void {
    const userDetails = this.authService.getUserDetails();
    if (this.$stateParams.searchString && this.$stateParams.searchString !== '') {
      // Reset Filters
      this.defaultFilters = new CandidatesQueryFilter(userDetails.company.companyId, userDetails.id);
      this.candidatesContainer.candidatesQueryFilter = _.cloneDeep(this.defaultFilters);
      this.candidatesContainer.candidatesQueryFilter.searchString = this.$stateParams.searchString;
      this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
      this.savedFilters = _.cloneDeep(this.candidatesContainer.candidatesQueryFilter);
      // Reset Display Filters
      this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
      this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
      this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
      this.savedDisplayedCandidateSelectedFilter = _.cloneDeep(this.displayCandidateSelectedFilter);
    }

    if (this.$stateParams.visibilityFilters !== null) {
      this.visibilityFilters = this.$stateParams.visibilityFilters;
      if (this.visibilityFilters.unassigned !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
      }
      if (this.visibilityFilters.assignedToMe !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
      }
      if (this.visibilityFilters.assignedToOthers !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
      }
    } else {
      this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
      this.visibilityFilters.unassigned = 'unassigned';
      this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
      this.visibilityFilters.assignedToOthers = 'assignedToOthers';
      this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
      this.visibilityFilters.assignedToMe = 'assignedToMe';
    }

    if (this.$stateParams.candidateType !== null) {
      this.candidatesContainer.candidatesQueryFilter.candidateType = this.$stateParams.candidateType;
    }
    this.storageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType, '');
  }

  _handleFilterDisplay(): void {
    $(document).ready(() => {
      $('#search-panel').hide();
      $(document).off('click', '#open-filter').on('click', '#open-filter', () => {
        $('#search-panel').animate({
          height: 'toggle'
        });
        this.showFiltersPanel = !this.showFiltersPanel;
      });
    });
  }

  _setCandidatesSortFilter(): void {
    if (this.savedFilters !== null && this.savedFilters.sortDirection !== undefined && this.savedFilters.column !== undefined) {
      this.sortByFilters.forEach(filter => {
        if (filter.column === this.savedFilters.column) {
          this.selectedSort = filter.columnDisplayName;
        }
      });
      this.candidatesContainer.candidatesQueryFilter.column = this.savedFilters.column;
      if (this.savedFilters.sortDirection === 'DESC') {
        this.selectedSortDirection = 'Desc';
        this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
      } else {
        this.selectedSortDirection = 'Asc';
        this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
      }
    }
    if (this.savedDisplayedCandidateSelectedFilter.selectedFilterSort.length > 0 || this.savedDisplayedCandidateSelectedFilter.searchString.length > 0) {
      this.setCandidateDisplayedFilterItemSelected(this.savedDisplayedCandidateSelectedFilter);
    }
  }

  _setSalaryAndRate(): void {
    this.candidatesContainer.candidatesQueryFilter.includeWithoutCompensation = true;
    this._setSalaryAndRateDefaultValues('salary');
    this._setSalaryAndRateDefaultValues('rate');
  }

  _setDisplaySalaryAndRateFilter(): void {
    if (this.displayCandidateSelectedFilter.salary !== '' && this.displayCandidateSelectedFilter.rate !== '') {
      this.isDisplayRateFilterActive = true;
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  setCandidateDisplayedFilterItemSelected(itemsSelected: any): void {
    this.emptyCandidateSelectedFilter = false;
    for (const key in itemsSelected) {
      if (itemsSelected.hasOwnProperty(key)) {
        const obj = itemsSelected[key];
        if (obj.length > 0) {
          this.displayCandidateFilterFlag = true;
          this.displaySelectedFilterObj = {};

          if (this.candidateFilterItemsSelected.length !== 0) {
            this.candidateFilterItemsSelected.forEach((filterItem: any) => {
              if (filterItem.filter === key) {
                if (filterItem.setSelectedFilterLimit === 5) {
                  this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                } else {
                  this.displaySelectedFilterObj = {
                    filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter
                  };
                }
              }
            });
          }

          if (this.candidateFilterItemsSelected.length === 0 || Object.keys(this.displaySelectedFilterObj).length === 0) {
            this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
          }

          this._setObjectVariableName(this.displaySelectedFilterObj);

          if (this.candidateFilterItemsSelected.length > 0) {
            this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter((item: any) => item.variable !== this.displaySelectedFilterObj.variable);
          }
          this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
        } else {
          if (this.candidateFilterItemsSelected.length > 0) {
            this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter((item: any) => item.filter !== key);
          }
        }
      }
    }
    if (this.candidateFilterItemsSelected.length === 0) {
      if (!this.candidatesContainer.isFilterOn) {
        this.displayCandidateFilterFlag = false;
        this._setShowCandidateDisplayFilterIcon(true);
      } else {
        this.emptyCandidateSelectedFilter = true;
      }
    }
  }

  _setFilterValues(filterName: string, value: any): void {
    switch (filterName) {
      case 'CandidateStatus':
        this.candidateStatusList.forEach((candidateStatus: any) => {
          if (value.indexOf(candidateStatus.value) !== -1) {
            candidateStatus.ticked = true;
          }
        });
        break;
      case 'Recruiters':
        this.recruitersList.forEach((recruiter: any) => {
          if (value.indexOf(recruiter.userId) !== -1) {
            recruiter.ticked = true;
          }
        });
        break;
      default:
        break;
    }
  }

  _setSalaryAndRateDisplayFilter(type: string): string {
    let salaryOrRateFilter = '';
    if (type === 'salary') {
      salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.salary
        ? `${this.candidatesContainer.candidatesQueryFilter.salary.toString()} ${this.candidatesContainer.candidatesQueryFilter.currency} ${this._setDisplayFilterSalaryOrRateDuration('salary')}`
        : '';
    } else {
      salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.rate
        ? `${this.candidatesContainer.candidatesQueryFilter.rate.toString()} ${this.candidatesContainer.candidatesQueryFilter.currency} ${this._setDisplayFilterSalaryOrRateDuration('rate')}`
        : '';
    }

    return salaryOrRateFilter;
  }

  _setDisplayFilterSalaryOrRateDuration(type: string): string {
    let durationOption = '';
    if (type === 'salary') {
      durationOption = this.salaryDurationOptions.filter((val: any) => this.candidatesContainer.candidatesQueryFilter.salaryDuration === val.value)[0].name;
    } else {
      durationOption = this.salaryDurationOptions.filter((val: any) => this.candidatesContainer.candidatesQueryFilter.rateDuration === val.value)[0].name;
    }

    return durationOption;
  }

  _setSalaryAndRateDefaultValues(type: string): void {
    if (type === 'salary') {
      this.candidatesContainer.candidatesQueryFilter.salary = null;
      this.candidatesContainer.candidatesQueryFilter.salaryDuration = 'PER_YEAR';
      this.candidatesContainer.candidatesQueryFilter.currency = 'USD';
    } else {
      this.candidatesContainer.candidatesQueryFilter.rate = null;
      this.candidatesContainer.candidatesQueryFilter.rateDuration = 'PER_HOUR';
      this.candidatesContainer.candidatesQueryFilter.currency = 'USD';
    }
  }

  _checkIfSalaryAndRateDurationDefault(type: string): void {
    if (type === 'salary') {
      if (!this.candidatesContainer.candidatesQueryFilter.salaryDuration || this.candidatesContainer.candidatesQueryFilter.salaryDuration === '') {
        this.candidatesContainer.candidatesQueryFilter.salaryDuration = 'PER_YEAR';
      }
    } else {
      if (!this.candidatesContainer.candidatesQueryFilter.rateDuration || this.candidatesContainer.candidatesQueryFilter.rateDuration === '') {
        this.candidatesContainer.candidatesQueryFilter.rateDuration = 'PER_HOUR';
      }
    }

    if (!this.candidatesContainer.candidatesQueryFilter.currency || this.candidatesContainer.candidatesQueryFilter.currency === '') {
      this.candidatesContainer.candidatesQueryFilter.currency = 'USD';
    }
  }

  _setShowCandidateDisplayFilterIcon(showIcon: boolean): void {
    const savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
    savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon = showIcon;
    this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, savedDisplayedCandidateSelectedFilter);
    if (this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon !== showIcon) {
      this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = showIcon;
    }
  }

  displaySelectedFilterToggle(): void {
    this.showCandidateDisplaySelectedFilterPanel = true;
    if (this.displayCandidateFilterFlag) {
      $('#display-candidate-selected-filter-panel').animate({
        height: 'toggle'
      });
      this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;
    }
    this._setShowCandidateDisplayFilterIcon(this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon);
  }

  isFilterValueArray(value: any): boolean {
    return Array.isArray(value);
  }

  addToDisplayFilters(event: string): void {
    switch (event) {
      case 'firstName':
        this.displayCandidateSelectedFilter.firstName = this.candidatesContainer.candidatesQueryFilter.firstName;
        break;
      case 'lastName':
        this.displayCandidateSelectedFilter.lastName = this.candidatesContainer.candidatesQueryFilter.lastName;
        break;
      case 'phone':
        this.displayCandidateSelectedFilter.phone = this.candidatesContainer.candidatesQueryFilter.phone;
        break;
      case 'email':
        this.displayCandidateSelectedFilter.email = this.candidatesContainer.candidatesQueryFilter.email;
        break;
      case 'search':
        this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
        break;
      case 'salary':
        if (this.candidatesContainer.candidatesQueryFilter.salary === undefined || this.candidatesContainer.candidatesQueryFilter.salary < 0) {
          this.candidatesContainer.candidatesQueryFilter.salary = 1;
        }
        this._checkIfSalaryAndRateDurationDefault('salary');
        this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        break;
      case 'rate':
        if (this.candidatesContainer.candidatesQueryFilter.rate === undefined || this.candidatesContainer.candidatesQueryFilter.rate < 0) {
          this.candidatesContainer.candidatesQueryFilter.rate = 1;
        }
        this._checkIfSalaryAndRateDurationDefault('rate');
        this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this.isDisplayRateFilterActive = true;
        break;
      default:
        break;
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  _setObjectVariableName(currentObject: any): void {
    const selectedFilterVariableNameObj: any = {
      requisitionStatus: 'Requisition Status', requisitionNumbers: 'Requisition Number',
      firstName: 'First Name', lastName: 'Last Name', phone: 'Phone', email: 'Email',
      searchString: 'Search', workflowStates: 'Job Match Status',
      recruiterList: 'Recruiter/Hiring Manager', workLocationIds: 'Work Locations',
      jobTypes: 'Job Type', jobSubTypes: 'Additional Contract Types', sponsorships: 'Work Authorizations', salary: 'Salary',
      rate: 'Rate', selectedFilterSort: 'Sort By'
    };

    for (const key in selectedFilterVariableNameObj) {
      if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
        const obj = selectedFilterVariableNameObj[key];
        if (key === currentObject.variable) {
          this.displaySelectedFilterObj.variable = obj;
        }
      }
    }
  }

  _setOpenGlobalFilter(): void {
    if (!this.showFiltersPanel) {
      $('#search-panel').animate({
        height: 'toggle'
      });
      this.showFiltersPanel = true;
    }
  }

  _deleteSelectedItem(currentObject: any, deletedItem: any): void {
    switch (currentObject.variable) {
      case 'firstName':
        this.candidatesContainer.candidatesQueryFilter.firstName = '';
        this.displayCandidateSelectedFilter.firstName = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'lastName':
        this.candidatesContainer.candidatesQueryFilter.lastName = '';
        this.displayCandidateSelectedFilter.lastName = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'phone':
        this.candidatesContainer.candidatesQueryFilter.phone = '';
        this.displayCandidateSelectedFilter.phone = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'email':
        this.candidatesContainer.candidatesQueryFilter.email = '';
        this.displayCandidateSelectedFilter.email = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'searchString':
        this.candidatesContainer.candidatesQueryFilter.searchString = '';
        this.displayCandidateSelectedFilter.searchString = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'clientOrBuList':
        this.clientOrBuList.forEach((client: any) => {
          if (client.name === deletedItem) {
            client.ticked = false;
            this.selectedClientOrBuList = this.selectedClientOrBuList.filter(item => item.name !== deletedItem);
          } else if (client.shortName === deletedItem) {
            client.ticked = false;
            this.selectedClientOrBuList = this.selectedClientOrBuList.filter(item => item.shortName !== deletedItem);
          }
        });
        this.onClientClick();
        break;
      case 'status':
        this.candidateStatusList.forEach((canStatus: any) => {
          if (canStatus.value === deletedItem) {
            canStatus.ticked = false;
            this.selectedCandidateStatusList = this.selectedCandidateStatusList.filter(item => item.value !== deletedItem);
          }
        });
        this.onCandidateStatusClick();
        break;
      case 'requisitionStatus':
        this.requisitionStatusList.forEach((reqStatus: any) => {
          if (reqStatus.name === deletedItem) {
            reqStatus.ticked = false;
            this.selectedRequisitionStatusList = this.selectedRequisitionStatusList.filter(item => item.name !== deletedItem);
          }
        });
        this.onRequisitionStatusClick();
        break;
      case 'requisitionNumbers':
        this.requisitionNumbersList.forEach((reqNum: any) => {
          if (reqNum.value === deletedItem) {
            reqNum.ticked = false;
            this.selectedRequisitionNumbersList = this.selectedRequisitionNumbersList.filter(item => item.value !== deletedItem);
          }
        });
        this.onRequisitionNumbersClick();
        break;
      case 'workflowStates':
        this.jobMatchStates.forEach((jobMatch: any) => {
          if (jobMatch.value === deletedItem) {
            jobMatch.ticked = false;
            this.selectedJobMatchStates = this.selectedJobMatchStates.filter(item => item.value !== deletedItem);
          }
        });
        this.onJobMatchStateClick();
        break;
      case 'vendors':
        this.vendors.forEach((vendor: any) => {
          if (vendor.name === deletedItem) {
            vendor.ticked = false;
            this.selectedVendors = this.selectedVendors.filter(item => item.name !== deletedItem);
          }
        });
        this.onVendorClick();
        break;
      case 'recruiterList':
        this.recruitersList.forEach((recruiter: any) => {
          if (recruiter.name === deletedItem) {
            recruiter.ticked = false;
            this.selectedRecruitersList = this.selectedRecruitersList.filter(item => item.name !== deletedItem);
          } else if (recruiter.firstName === deletedItem) {
            recruiter.ticked = false;
            this.selectedRecruitersList = this.selectedRecruitersList.filter(item => item.firstName !== deletedItem);
          }
        });
        this.onRecruiterClick();
        break;
      case 'workLocationIds':
        this.workLocationList.forEach((workLocation: any) => {
          if (workLocation.name === deletedItem) {
            workLocation.ticked = false;
            this.selectedWorkLocationList = this.selectedWorkLocationList.filter(item => item.name !== deletedItem);
          }
        });
        this.onWorkLocationClick();
        break;
      case 'jobTypes':
        this.preferredJobTypeList.forEach((jobType: any) => {
          if (jobType.name === deletedItem) {
            jobType.ticked = false;
            this.selectedPreferredJobTypeList = this.selectedPreferredJobTypeList.filter(item => item.name !== deletedItem);
          }
        });
        this.onPreferredJobTypeClick();
        break;
      case 'jobSubTypes':
        this.preferredJobTypeAdditionalList.forEach((additionalJobType: any) => {
          if (additionalJobType.name === deletedItem) {
            additionalJobType.ticked = false;
            this.selectedPreferredJobTypeAdditionalList = this.selectedPreferredJobTypeAdditionalList.filter(item => item.name !== deletedItem);
          }
        });
        this.onAdditionalPreferredJobTypeClick();
        break;
      case 'sponsorships':
        this.workAuthorizationList.forEach((sponsorship: any) => {
          if (sponsorship.value === deletedItem) {
            sponsorship.ticked = false;
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.value !== deletedItem);
          } else if (sponsorship.name === deletedItem) {
            sponsorship.ticked = false;
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.name !== deletedItem);
          }
        });
        this.onWorkAuthorizationClick();
        break;
      case 'salary':
        this.candidatesContainer.candidatesQueryFilter.salary = null;
        this.displayCandidateSelectedFilter.salary = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'rate':
        this.candidatesContainer.candidatesQueryFilter.rate = null;
        this.displayCandidateSelectedFilter.rate = '';
        this.isDisplayRateFilterActive = false;
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        break;
      case 'selectedFilterSort':
        this.sortCandidates(null, '');
        break;
      default:
        break;
    }
  }

  deleteSelectedFilterItem(deletedItem: any): void {
    this._setOpenGlobalFilter();

    for (const key in this.displayCandidateSelectedFilter) {
      if (this.displayCandidateSelectedFilter.hasOwnProperty(key)) {
        const obj = this.displayCandidateSelectedFilter[key];
        if (Array.isArray(obj)) {
          if (obj.includes(deletedItem)) {
            this.deleteSelectedFilter = {};
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
          }
        } else {
          if (obj === deletedItem) {
            this.deleteSelectedFilter = {};
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
          }
        }
      }
    }
  }

  onGlobalFilterChange(event?: any): void {
    this.isFiltersChanged = true;
    if (!this.showFiltersPanel) {
      $('#search-panel').animate({
        height: 'toggle'
      });
      this.showFiltersPanel = true;
    }
    if (this._onEnterKeyPress(event)) {
      this.queryCandidates();
    }
  }

  _onEnterKeyPress(event: any): boolean {
    return event && event.keyCode === 13;
  }

  candidateJobMatchesTabChanged(type: string): void {
    this.candidateJobMatchActiveTab.candidateInfoContainerId = this.candidateInfoContainerId;
    this.candidateJobMatchActiveTab.type = type;
    switch (type) {
      case 'jobMatches':
        this.activeTabIndex = 1;
        break;
      case 'possibleJobMatches':
        this.activeTabIndex = 2;
        break;
      default:
        this.activeTabIndex = 1;
        break;
    }
  }

  filterByDate(): void {
    this.candidatesContainer.candidatesQueryFilter.fromDate = '';
    this.candidatesContainer.candidatesQueryFilter.toDate = '';
    if (this.selectedDateRange !== undefined && this.selectedDateRange !== '') {
      const array = this.selectedDateRange.split('-');
      this.candidatesContainer.candidatesQueryFilter.fromDate = array[0].toString().trim();
      this.candidatesContainer.candidatesQueryFilter.toDate = array[1].toString().trim();
    } else {
      this.selectedDateRange = '';
    }
  }

  setCandidateInfo(candidateInfo: any, type: string): void {
    if (this.candidateInfoContainerId !== null) {
      this.closeCandidateInfoRow();
    }
    this.infoOfCandidateInContext = candidateInfo;

    const allCandidatesLength = this.candidatesContainer.candidates.length;
    const allCandidatesFullQuadrants = Math.floor(allCandidatesLength / this.divident);
    const currentCandidateQuadrant = Math.ceil(candidateInfo.candidateIndex / this.divident);
    let candidateInfoContainerId: string | null = null;
    if (this.isRowViewActive) {
      candidateInfoContainerId = `candidate-info-row-view-${candidateInfo.candidateIndex}`;
    } else {
      if (currentCandidateQuadrant <= allCandidatesFullQuadrants) {
        candidateInfoContainerId = 'candidate-info-' + (currentCandidateQuadrant * this.divident);
      } else {
        candidateInfoContainerId = 'candidate-info-' + allCandidatesLength;
      }
    }
    switch (type) {
      case 'jobMatches':
        this.activeTabIndex = 1;
        break;
      case 'possibleJobMatches':
        this.activeTabIndex = 2;
        break;
      default:
        this.activeTabIndex = 1;
        break;
    }
    // time out needed for variables to refresh on view and reload the job matches directive.
    setTimeout(() => {
      this.candidateInfoContainerId = candidateInfoContainerId;
      candidateInfo.jobMatchesPopoverIsOpenFlag = false;
      $('#' + candidateInfoContainerId).show();
      this.candidateJobMatchesTabChanged(type);
    }, 100);
  }

  deleteCandidate(candidateId: string): void {
    if (this.isRowViewActive) {
      const rowViewCandidateIndex = this.candidatesContainer.candidatesPerPage.findIndex((candidate: any) => candidate.id === candidateId);
      this.candidatesContainer.candidatesPerPage.splice(rowViewCandidateIndex, 1);
    } else {
      const candidateIndex = this.candidatesContainer.candidates.findIndex((candidate: any) => candidate.id === candidateId);
      this.candidatesContainer.candidates.splice(candidateIndex, 1);
    }
    this.candidatesContainer.candidatesCount = this.candidatesContainer.candidatesCount - 1;
  }

  onCandidatesTypeChanged(): void {
    this.candidateInfoContainerId = null;
    this.candidateJobMatchesTabChanged('jobMatches');
    this.storageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType, '');
    this.queryCandidates();

    if (this.candidatesContainer.candidatesQueryFilter.candidateType === 'OWN_CANDIDATES') {
      this.displayCandidateSelectedFilter.vendors = [];
      this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    } else {
      this.onVendorClick();
      this._setSalaryAndRateDefaultValues('salary');
      this._setSalaryAndRateDefaultValues('rate');
      this.displayCandidateSelectedFilter.salary = '';
      this.displayCandidateSelectedFilter.rate = '';
      this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
  }

  resetCandidateQueryFilters(): void {
    this.isFiltersChanged = true;
    this.selectedDateRange = '';
    this.candidateStatusList.forEach((val: any) => { val.ticked = false; });
    this.recruitersList.forEach((val: any) => { val.ticked = false; });
    this.vendors.forEach((val: any) => { val.ticked = false; });
    this.requisitionNumbersList.forEach((val: any) => { val.ticked = false; });
    this.requisitionStatusList.forEach((val: any) => { val.ticked = false; });
    this.clientOrBuList.forEach((val: any) => { val.ticked = false; });
    this.jobMatchStates.forEach((val: any) => { val.ticked = false; });
    this.workLocationList.forEach((val: any) => { val.ticked = false; });
    this.preferredJobTypeList.forEach((val: any) => { val.ticked = false; });
    if (this.preferredJobTypeAdditionalList) {
      this.preferredJobTypeAdditionalList.forEach((val: any) => { val.ticked = false; });
    }
    this.workAuthorizationList.forEach((val: any) => { val.ticked = false; });
    // the ng-select controls are driven by these ngModel-bound arrays, not by
    // the .ticked flags above - without clearing them the selects kept
    // showing their previous selections after Reset
    this.selectedCandidateStatusList = [];
    this.selectedRecruitersList = [];
    this.selectedVendors = [];
    this.selectedRequisitionNumbersList = [];
    this.selectedRequisitionStatusList = [];
    this.selectedClientOrBuList = [];
    this.selectedJobMatchStates = [];
    this.selectedWorkLocationList = [];
    this.selectedPreferredJobTypeList = [];
    this.selectedPreferredJobTypeAdditionalList = [];
    this.selectedWorkAuthorizationList = [];
    if (this.selectedSort !== 'Please Select') {
      this.selectedSort = 'Please Select';
      this.selectedSortDirection = '';
      delete this.candidatesContainer.candidatesQueryFilter.column;
      delete this.candidatesContainer.candidatesQueryFilter.sortDirection;
    }
    const userDetails = this.authService.getUserDetails();
    this.candidatesContainer.candidatesQueryFilter = new CandidatesQueryFilter(userDetails.company.companyId, userDetails.id);
    // Reset Salary and Rate
    this._setSalaryAndRate();
    // to set existing visibility filters
    this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
    this.visibilityFilters.unassigned = 'unassigned';
    this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
    this.visibilityFilters.assignedToOthers = 'assignedToOthers';
    this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
    this.visibilityFilters.assignedToMe = 'assignedToMe';
    // Reset Displayed Selected Filters
    this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
    const savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
    this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon;
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  // ng-select's built-in ng-multi-label-tmp extension point: collapses the closed
  // control to "First selection (N)" instead of stacking every chip, per selection.
  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  selectRemoveAll(label: string, type: string, _doQueryFlag?: boolean): void {
    if (type === 'selectAll') {
      switch (label) {
        case 'Clients':
          this.selectedClientOrBuList = [...this.clientOrBuList];
          this.onClientClick();
          break;
        case 'CandidateStatus':
          this.selectedCandidateStatusList = [...this.candidateStatusList];
          this.onCandidateStatusClick();
          break;
        case 'RequisitionStatus':
          this.selectedRequisitionStatusList = [...this.requisitionStatusList];
          this.onRequisitionStatusClick();
          break;
        case 'Recruiters':
          this.selectedRecruitersList = [...this.recruitersList];
          this.onRecruiterClick();
          break;
        case 'Vendors':
          this.selectedVendors = [...this.vendors];
          this.onVendorClick();
          break;
        case 'RequisitionNumbers':
          this.selectedRequisitionNumbersList = [...this.requisitionNumbersList];
          this.onRequisitionNumbersClick();
          break;
        case 'JobMatchStates':
          this.selectedJobMatchStates = [...this.jobMatchStates];
          this.onJobMatchStateClick();
          break;
        case 'WorkLocations':
          this.selectedWorkLocationList = [...this.workLocationList];
          this.onWorkLocationClick();
          break;
        case 'PreferredJobType':
          this.selectedPreferredJobTypeList = [...this.preferredJobTypeList];
          this.onPreferredJobTypeClick();
          break;
        case 'jobSubTypes':
          this.selectedPreferredJobTypeAdditionalList = [...this.preferredJobTypeAdditionalList];
          this.onAdditionalPreferredJobTypeClick();
          break;
        case 'sponsorships':
          this.selectedWorkAuthorizationList = [...this.workAuthorizationList];
          this.onWorkAuthorizationClick();
          break;
        default:
        // do nothing
      }
    } else {
      switch (label) {
        case 'Clients':
          this.selectedClientOrBuList = [];
          this.onClientClick();
          break;
        case 'CandidateStatus':
          this.selectedCandidateStatusList = [];
          this.onCandidateStatusClick();
          break;
        case 'RequisitionStatus':
          this.selectedRequisitionStatusList = [];
          this.onRequisitionStatusClick();
          break;
        case 'Recruiters':
          this.selectedRecruitersList = [];
          this.onRecruiterClick();
          break;
        case 'Vendors':
          this.selectedVendors = [];
          this.onVendorClick();
          break;
        case 'RequisitionNumbers':
          this.selectedRequisitionNumbersList = [];
          this.onRequisitionNumbersClick();
          break;
        case 'JobMatchStates':
          this.selectedJobMatchStates = [];
          this.onJobMatchStateClick();
          break;
        case 'WorkLocations':
          this.selectedWorkLocationList = [];
          this.onWorkLocationClick();
          break;
        case 'PreferredJobType':
          this.selectedPreferredJobTypeList = [];
          this.onPreferredJobTypeClick();
          break;
        case 'jobSubTypes':
          this.selectedPreferredJobTypeAdditionalList = [];
          this.onAdditionalPreferredJobTypeClick();
          break;
        case 'sponsorships':
          this.selectedWorkAuthorizationList = [];
          this.onWorkAuthorizationClick();
          break;
        default:
        // do nothing
      }
    }
  }

  _removeOtherRecruiters(): void {
    this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId === this.userId || recruiter.userId === 'UNASSIGNED');
    this.selectedRecruitersList = [...this.recruitersList];
  }

  visibilityFilterChanged(): void {
    this.onGlobalFilterChange();
    this.getAllRecruiters(() => {
      this.candidatesContainer.candidatesQueryFilter.visibility = [];
      if (this.visibilityFilters.assignedToMe !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
        if (this._currentUserExistsInAssignedRecruitersList()) {
          this.recruitersList.forEach((val: any) => {
            if (val.userId === this.userId) {
              val.ticked = true;
            }
          });
        } else if (!this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
          this.recruitersList.unshift({
            name: this.userName, selectedDisplayName: this.displayOnMultiSelectPipe.transform(this.userName),
            userId: this.userId, ticked: true
          });
        }
      } else {
        this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== this.userId);
      }

      this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== 'UNASSIGNED');
      if (this.visibilityFilters.unassigned !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
        const unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED', ticked: true };
        this.recruitersList.unshift(unAssignedRecruiter);
      }

      this.selectedRecruitersList = [];
      this.recruitersList.forEach((val: any) => {
        if (val.userId !== this.userId && val.userId !== 'UNASSIGNED') {
          val.ticked = true;
        }
        if (val.ticked) {
          this.selectedRecruitersList.push(val);
        }
      });

      if (this.visibilityFilters.assignedToOthers !== '') {
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
      } else {
        this._removeOtherRecruiters();
      }
      if (this.candidatesContainer.candidatesQueryFilter.visibility.length === 3) {
        this.candidatesContainer.allAssignedRecruitersCount = this.recruitersList.length;
      }

      this.onRecruiterClick();
    });
  }

  candidateCompensationChanged(): void {
    this.onGlobalFilterChange();
  }

  onClientClick(): void {
    this.isFiltersChanged = true;
    this.getAllRequisitionNumbers(() => {
      this.getAllRecruiters(() => {
        this.candidatesContainer.candidatesQueryFilter.clientOrBuList = this.selectedClientOrBuList.map((val: any) => val.id);
        this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val: any) => val.value);
        this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val: any) => val.userId);

        this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val: any) =>
          val.companyType === 'Corporation' ? val.shortName : val.name);
        this.displayCandidateSelectedFilter.requisitionNumbers = this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
        this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val: any) =>
          val.firstName === null || val.firstName === undefined ? val.name : val.firstName);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      });
    });
  }

  onJobMatchStateClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.workflowStates = this.selectedJobMatchStates.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.workflowStates = this.candidatesContainer.candidatesQueryFilter.workflowStates;
    this.displayCandidateSelectedFilter.workflowStates = this.displayCandidateSelectedFilter.workflowStates.filter((val: any) => val !== undefined);
    this.displayCandidateSelectedFilter.workflowStates = [...new Set(this.displayCandidateSelectedFilter.workflowStates)];
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onWorkLocationClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.workLocationIds = this.selectedWorkLocationList.map((val: any) => val.id);

    this.displayCandidateSelectedFilter.workLocationIds = this.selectedWorkLocationList.map((val: any) => val.name);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onPreferredJobTypeClick(): void {
    this.isFiltersChanged = true;

    this.candidatesContainer.candidatesQueryFilter.jobTypes = this.selectedPreferredJobTypeList.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.jobTypes = this.selectedPreferredJobTypeList.map((val: any) => val.name);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    this.onAdditionalPreferredJobTypeClick();
  }

  onAdditionalPreferredJobTypeClick(): void {
    this.isFiltersChanged = true;

    if (!this.checkPreferredJobType('CONTRACTTOHIRE') && !this.checkPreferredJobType('CONTRACTOR')) {
      this.selectedPreferredJobTypeAdditionalList = [];
    }

    this.candidatesContainer.candidatesQueryFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val: any) => val.name);

    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  checkPreferredJobType(jobType: string): boolean {
    let isJobTypePresent = false;

    if (this.selectedPreferredJobTypeList && this.selectedPreferredJobTypeList.length > 0) {
      for (const type of this.selectedPreferredJobTypeList) {
        if (type.value === jobType) {
          isJobTypePresent = true;
          break;
        } else {
          isJobTypePresent = false;
        }
      }
    }

    return isJobTypePresent;
  }

  onWorkAuthorizationClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.sponsorships = this.selectedWorkAuthorizationList.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val: any) => val.name);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onSalaryDurationChange(): void {
    if (this.candidatesContainer.candidatesQueryFilter.salaryDuration) {
      this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onRateDurationChange(): void {
    if (this.candidatesContainer.candidatesQueryFilter.rateDuration) {
      this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onSalaryOrRateCurrencyChange(type: string): void {
    if (this.displayCandidateSelectedFilter.rate !== '' || this.displayCandidateSelectedFilter.salary !== '') {
      this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
      this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    } else if (type === 'salary') {
      this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
    } else {
      this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onCandidateStatusClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.status = this.selectedCandidateStatusList.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.status = this.candidatesContainer.candidatesQueryFilter.status;
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onRequisitionStatusClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val: any) => val.value);

    this.displayCandidateSelectedFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val: any) => val.name);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onRecruiterClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val: any) => val.userId);

    this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val: any) =>
      val.firstName === null || val.firstName === undefined ? val.name : val.firstName);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onVendorClick(): void {
    this.isFiltersChanged = true;
    this.candidatesContainer.candidatesQueryFilter.vendors = this.selectedVendors.map((val: any) => val.id);

    this.displayCandidateSelectedFilter.vendors = this.selectedVendors.map((val: any) => val.name);
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  onRequisitionNumbersClick(): void {
    this.isFiltersChanged = true;
    this.getAllRecruiters(() => {
      this.candidatesContainer.candidatesQueryFilter.clientOrBuList = this.selectedClientOrBuList.map((val: any) => val.id);
      this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val: any) => val.value);
      this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val: any) => val.userId);

      this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val: any) =>
        val.companyType === 'Corporation' ? val.shortName : val.name);
      this.displayCandidateSelectedFilter.requisitionNumbers = this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
      this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val: any) =>
        val.firstName === null || val.firstName === undefined ? val.name : val.firstName);
      this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    });
  }

  sortCandidates(sortByFilter: any, direction: string): void {
    this.isFiltersChanged = true;
    if (sortByFilter === null) {
      this.selectedSort = 'Please Select';
      this.selectedSortDirection = '';
      delete this.candidatesContainer.candidatesQueryFilter.column;
      delete this.candidatesContainer.candidatesQueryFilter.sortDirection;
    } else {
      this.selectedSort = sortByFilter.columnDisplayName;
      this.candidatesContainer.candidatesQueryFilter.column = sortByFilter.column;
      this.selectedSortDirection = 'Asc';
      this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
      if (direction === 'Desc') {
        this.selectedSortDirection = 'Desc';
        this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
      }
    }

    this.displayCandidateSelectedFilter.selectedFilterSort = '';
    if (sortByFilter != null) {
      this.displayCandidateSelectedFilter.selectedFilterSort = sortByFilter.columnDisplayName + ' ' + '(' + direction + ')';
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
  }

  getAllClientsOrBu(successCallback?: () => void): void {
    this.loadingClientsOrBusFilter = true;
    const userDetails = this.authService.getUserDetails();
    this.candidateService.getAllClientsOrBu(userDetails, (data: any) => {
      this.clientOrBuList = data;

      if (this.savedFilters !== null) {
        this.selectedClientOrBuList = this.clientOrBuList.filter((clientOrBu: any) =>
          this.savedFilters.clientOrBuList.some((clientOrBuId: any) => clientOrBuId === clientOrBu.id));
        this.selectedClientOrBuList.forEach(clientOrBu => clientOrBu.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.clientOrBuList.length !== 0 || this.candidatesContainer.candidatesQueryFilter.clientOrBuList.length !== 0) {
        this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val: any) => {
          return val.companyType === 'Corporation' ? val.shortName : val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }
      this.loadingClientsOrBusFilter = false;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.loadingClientsOrBusFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllRequisitionNumbers(successCallback?: () => void): void {
    this.loadingRequisitionNumbersFilter = true;
    const userDetails = this.authService.getUserDetails();
    const clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => clientOrBu.id);
    const filter = { clientOrBuIds, roleNames: [] };
    this.jobService.searchByReqNum(userDetails.id, userDetails.company.companyId, 'all', filter, (data: any) => {
      this.requisitionNumbersList = [];
      data.forEach((req: any) => {
        const icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
        this.requisitionNumbersList.push({
          name: req.reqNumber, value: req.reqNumber,
          selectedDisplayName: this.displayOnMultiSelectPipe.transform(req.reqNumber), icon
        });
      });

      this.selectedRequisitionNumbersList = this.selectedRequisitionNumbersList.filter(selectedReqNumber =>
        this.requisitionNumbersList.find((reqNumber: any) => reqNumber.name === selectedReqNumber.name));
      this.selectedRequisitionNumbersList.forEach((selectedReqNumber: any) => {
        this.requisitionNumbersList.forEach((reqNum: any) => {
          if (reqNum.name === selectedReqNumber.name) {
            reqNum.ticked = true;
          }
        });
      });

      if (this.savedFilters !== null) {
        this.selectedRequisitionNumbersList = this.requisitionNumbersList.filter((reqNum: any) =>
          this.savedFilters.requisitionNumbers.some((num: any) => num === reqNum.value));
        this.selectedRequisitionNumbersList.forEach(req => req.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.requisitionNumbers.length !== 0 || this.candidatesContainer.candidatesQueryFilter.requisitionNumbers.length !== 0) {
        this.displayCandidateSelectedFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val: any) => val.value);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }
      if (successCallback) {
        successCallback();
      }
      this.loadingRequisitionNumbersFilter = false;
    }, (error: any) => {
      this.loadingRequisitionNumbersFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onReqNumsSearch(event: any): void {
    this.getReqNums(event.term);
  }

  getReqNums(searchReqText: string): void {
    if (searchReqText === '' || searchReqText === undefined) {
      searchReqText = 'all';
    }
    const userDetails = this.authService.getUserDetails();
    const clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => clientOrBu.id);
    const filter = { clientOrBuIds, roleNames: [] };
    this.jobService.searchByReqNum(userDetails.id, userDetails.company.companyId, searchReqText, filter, (data: any) => {
      this.requisitionNumbersList = [];
      data.forEach((req: any) => {
        const icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
        this.requisitionNumbersList.push({
          name: req.reqNumber, value: req.reqNumber,
          selectedDisplayName: this.displayOnMultiSelectPipe.transform(req.reqNumber), icon
        });
      });
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllRecruiters(successCallback?: () => void): void {
    this.loadingRecruitersFilter = true;
    const userDetails = this.authService.getUserDetails();
    const clientOrBuId = null;
    const requisitionId = null;
    const clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => clientOrBu.id);
    const requisitionNumbers = this.selectedRequisitionNumbersList.map(reqNumber => reqNumber.name);
    const isUploadOrEditReq = false;

    this.jobService.getAllRecruiters(userDetails, userDetails.company, clientOrBuId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, (data: any) => {
      this.recruitersList = data.recruiters;
      this.recruitersList.forEach((val: any) => {
        let name = val.lastName !== null ? val.firstName + ' ' + val.lastName : val.firstName;
        val.selectedDisplayName = this.displayOnMultiSelectPipe.transform(name);
        val.name = name.length > 30 ? name.substring(0, 30) + '...' : name;
        val.name = val.name + ' <sup>R</sup>';
      });

      data.hiringManagers.forEach((val: any) => {
        let name = val.lastName !== null ? val.firstName + ' ' + val.lastName : val.firstName;
        val.selectedDisplayName = this.displayOnMultiSelectPipe.transform(name);
        val.name = name.length > 30 ? name.substring(0, 30) + '...' : name;
        val.name = val.name + ' <sup>H</sup>';
        this.recruitersList.push(val);
      });

      data.pocs.forEach((poc: any) => {
        if (poc) {
          let name = poc.lastName !== null ? poc.firstName + ' ' + poc.lastName : poc.firstName;
          poc.selectedDisplayName = this.displayOnMultiSelectPipe.transform(name);
          poc.name = name.length > 30 ? name.substring(0, 30) + '...' : name;
          poc.name = poc.name + ' <sup>POC</sup>';
          this.recruitersList.push(poc);
        }
      });

      if (this.visibilityFilters.unassigned !== '') {
        if (!this.recruitersList.find(recruiter => recruiter.userId === 'UNASSIGNED')) {
          const unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED' };
          this.recruitersList.unshift(unAssignedRecruiter);
        }
      }

      if (this.visibilityFilters.assignedToMe !== '') {
        if (!this._currentUserExistsInAssignedRecruitersList() && !this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
          this.recruitersList.unshift({
            name: this.userName, selectedDisplayName: this.displayOnMultiSelectPipe.transform(this.userName),
            userId: this.userId, ticked: true
          });
        }
      } else {
        this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== this.userId);
      }

      this.selectedRecruitersList = this.selectedRecruitersList.filter(selectedRecruiter =>
        this.recruitersList.find(recruiter => recruiter.userId === selectedRecruiter.userId));
      this.selectedRecruitersList.forEach((selectedRecruiter: any) => {
        this.recruitersList.forEach((recruiter: any) => {
          if (recruiter.userId === selectedRecruiter.userId) {
            recruiter.ticked = true;
          }
        });
      });

      if (this.savedFilters !== null) {
        this.selectedRecruitersList = this.recruitersList.filter(recruiter =>
          this.savedFilters.recruiterList.some((recruiterId: any) => recruiterId === recruiter.userId));
        this.selectedRecruitersList.forEach(recruiter => recruiter.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.recruiterList.length !== 0 || this.candidatesContainer.candidatesQueryFilter.recruiterList.length !== 0) {
        this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val: any) =>
          val.firstName === null || val.firstName === undefined ? val.name : val.firstName);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }

      if (successCallback) {
        successCallback();
      }
      this.loadingRecruitersFilter = false;
    }, (error: any) => {
      this.loadingRecruitersFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _currentUserExistsInAssignedRecruitersList(): boolean {
    return this.recruitersList.some(recruiter => recruiter.userId === this.userId);
  }

  getAllRequisitionStatuses(successCallback?: () => void): void {
    this.loadingRequisitionStatusesFilter = true;
    this.jobService.getAllStatusTypes((data: any) => {
      this.requisitionStatusList = data;
      if (this.savedFilters !== null) {
        this.selectedRequisitionStatusList = this.requisitionStatusList.filter((status: any) =>
          this.savedFilters.requisitionStatus.some((value: any) => value === status.value));
        this.selectedRequisitionStatusList.forEach(status => status.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.requisitionStatus.length !== 0 || this.candidatesContainer.candidatesQueryFilter.requisitionStatus.length !== 0) {
        this.displayCandidateSelectedFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }
      if (successCallback) {
        successCallback();
      }
      this.loadingRequisitionStatusesFilter = false;
    }, (error: any) => {
      this.loadingRequisitionStatusesFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllWorkLocations(successCallback?: () => void): void {
    this.loadingWorkLocationsFilter = true;
    this.jobService.getWorkLocations((data: any) => {
      this.workLocationList = data;
      if (this.savedFilters !== null && this.savedFilters.workLocationIds) {
        this.selectedWorkLocationList = this.workLocationList.filter((location: any) =>
          this.savedFilters.workLocationIds.some((id: any) => location.id === id));
        this.selectedWorkLocationList.forEach(location => location.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.workLocationIds.length !== 0 || this.candidatesContainer.candidatesQueryFilter.workLocationIds.length !== 0) {
        this.displayCandidateSelectedFilter.workLocationIds = this.selectedWorkLocationList.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }
      if (successCallback) {
        successCallback();
      }
      this.loadingWorkLocationsFilter = false;
    }, (error: any) => {
      this.loadingWorkLocationsFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllJobMatchStates(successCallback?: () => void): void {
    this.loadingJobMatchStatesFilter = true;
    this.jobMatchService.getAllJobMatchStates((data: any) => {
      data.candidateWorkflowCardStatus.forEach((stepVal: any) => {
        stepVal.states.forEach((stateVal: any) => {
          const stateEntry: any = {};
          stateEntry.name = stateVal;
          stateEntry.value = stateVal;
          stateEntry.label = stateVal;
          stateEntry.stepGroup = stepVal.status;
          stateEntry.ticked = false;
          this.jobMatchStates.push(stateEntry);
        });
        this.loadingJobMatchStatesFilter = false;
      });
      if (this.savedFilters !== null) {
        this.selectedJobMatchStates = this.jobMatchStates.filter((jobMatchState: any) =>
          this.savedFilters.workflowStates.some((stateName: any) => stateName === jobMatchState.value));
        this.selectedJobMatchStates.forEach(state => state.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.workflowStates.length !== 0 || this.candidatesContainer.candidatesQueryFilter.workflowStates.length !== 0) {
        this.displayCandidateSelectedFilter.workflowStates = this.selectedJobMatchStates.map((val: any) => val.value);
        this.displayCandidateSelectedFilter.workflowStates = this.displayCandidateSelectedFilter.workflowStates.filter((val: any) => val !== undefined);
        this.displayCandidateSelectedFilter.workflowStates = [...new Set(this.displayCandidateSelectedFilter.workflowStates)];
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }

      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.loadingJobMatchStatesFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllVendors(successCallback?: () => void): void {
    this.loadingVendorsFilter = true;
    const userDetails = this.authService.getUserDetails();
    this.companyService.getVendorsByUserScope(userDetails.company.companyId, (data: any) => {
      this.vendors = data;
      this.loadingVendorsFilter = false;
      if (this.savedFilters !== null) {
        this.selectedVendors = this.vendors.filter(vendor => this.savedFilters.vendors.some((vendorId: any) => vendorId === vendor.id));
        this.selectedVendors.forEach(vendor => vendor.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.vendors.length !== 0 || this.candidatesContainer.candidatesQueryFilter.vendors.length !== 0) {
        this.displayCandidateSelectedFilter.vendors = this.selectedVendors.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.loadingVendorsFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllCandidateStatuses(successCallback?: () => void): void {
    this.loadingCandidateStatusesFilter = true;
    this.candidateStatusList = [
      { name: 'Active', value: 'Active' },
      { name: 'Passive', value: 'Passive' },
      { name: 'Inert', value: 'Inert' }
    ];

    if (this.savedFilters !== null) {
      this.selectedCandidateStatusList = this.candidateStatusList.filter((status: any) =>
        this.savedFilters.status.some((statusName: any) => statusName === status.name));
      this.selectedCandidateStatusList.forEach((status: any) => status.ticked = true);
    }

    if (this.savedDisplayedCandidateSelectedFilter.status.length !== 0 || this.candidatesContainer.candidatesQueryFilter.status.length !== 0) {
      this.displayCandidateSelectedFilter.status = this.selectedCandidateStatusList.map((val: any) => val.value);
      this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    this.loadingCandidateStatusesFilter = false;
    if (successCallback) {
      successCallback();
    }
  }

  getAllActivityTypes(): void {
    this.jobService.getActivityTypes((data: any) => {
      this.activityMap = [];
      data.forEach((val: any) => {
        this.activityMap[val.value] = val.name;
      });
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getSalaryDurationOptions(): void {
    this.jobService.getSalaryDurationOptions((data: any) => {
      this.salaryDurationOptions = data;
      const tempSalaryDurationOptions = _.cloneDeep(data);
      tempSalaryDurationOptions.map((duration: any) => {
        duration.name = duration.name.slice(4);
      });
      this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter((salaryDuration: any) => salaryDuration.value === 'PER_YEAR');
      this.filterRateDurationOptions = tempSalaryDurationOptions.filter((rateDuration: any) => rateDuration.value !== 'PER_YEAR');
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes(): void {
    this.loadingPreferredJobTypeFilter = true;
    this.jobService.getAllJobTypes((data: any) => {
      this.preferredJobTypeList = data;
      this.preferredJobTypeList.push({ name: 'No Pref. Job Type', value: 'NO_PREF_JOBTYPE' });

      if (this.savedFilters !== null && this.savedFilters.jobTypes) {
        this.selectedPreferredJobTypeList = this.preferredJobTypeList.filter((jobType: any) =>
          this.savedFilters.jobTypes.some((value: any) => jobType.value === value));
        this.selectedPreferredJobTypeList.forEach((jobType: any) => jobType.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.jobTypes.length !== 0 || this.candidatesContainer.candidatesQueryFilter.jobTypes.length !== 0) {
        this.displayCandidateSelectedFilter.jobTypes = this.selectedPreferredJobTypeList.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }

      this.loadingPreferredJobTypeFilter = false;
    }, (error: any) => {
      this.loadingPreferredJobTypeFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllAdditionalPreferredJobTypes(): void {
    this.loadingAdditionalPreferredJobTypeFilter = true;
    this.jobService.getAllJobSubTypes((data: any) => {
      this.preferredJobTypeAdditionalList = data;
      this.preferredJobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });

      if (this.savedFilters !== null && this.savedFilters.jobSubTypes) {
        this.selectedPreferredJobTypeAdditionalList = this.preferredJobTypeAdditionalList.filter((jobType: any) =>
          this.savedFilters.jobSubTypes.some((value: any) => jobType.value === value));
        this.selectedPreferredJobTypeAdditionalList.forEach(jobType => jobType.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.jobSubTypes.length !== 0 || this.candidatesContainer.candidatesQueryFilter.jobSubTypes.length !== 0) {
        this.displayCandidateSelectedFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }

      this.loadingAdditionalPreferredJobTypeFilter = false;
    }, (error: any) => {
      this.loadingAdditionalPreferredJobTypeFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllWorkAuthorizations(): void {
    this.loadingWorkAuthorizationFilter = true;
    this.jobService.getAllSponsorshipTypes((data: any) => {
      this.workAuthorizationList = data;

      if (this.savedFilters !== null && this.savedFilters.sponsorships) {
        this.selectedWorkAuthorizationList = this.workAuthorizationList.filter((work: any) =>
          this.savedFilters.sponsorships.some((value: any) => work.value === value));
        this.selectedWorkAuthorizationList.forEach((jobType: any) => jobType.ticked = true);
      }

      if (this.savedDisplayedCandidateSelectedFilter.sponsorships.length !== 0 || this.candidatesContainer.candidatesQueryFilter.sponsorships.length !== 0) {
        this.displayCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val: any) => val.name);
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
      }

      this.loadingWorkAuthorizationFilter = false;
    }, (error: any) => {
      this.loadingWorkAuthorizationFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getCurrencyCodes(): void {
    this.jobService.getCurrencyCodes((data: any) => {
      this.currencyCodes = data;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  closeCandidateInfoRow(): void {
    if (this.candidateInfoContainerId !== null) {
      $('#' + this.candidateInfoContainerId).hide();
    }
    this.candidateInfoContainerId = null;
    this.sharedAjsService.resetRefreshJobMatchesListener();
    this.candidateJobMatchesTabChanged('jobMatches');
  }

  _scrollDownToKeepInfiniteScrollActive(): void {
    if ($(window).scrollTop() < 100) {
      window.scrollTo(0, 100);
    }
  }

  queryCandidates(): void {
    this.candidatesContainer.loadingSearchButton = true;
    this.isFiltersChanged = false;
    this.isDisplayRateFilterActive = false;
    this.closeCandidateInfoRow();
    if (this.showFiltersPanel) {
      this._scrollDownToKeepInfiniteScrollActive();
    }

    // clear any existing query requests
    if (this.candidatesContainer.currentPromise !== null) {
      this.genericService.cancelRequest(this.candidatesContainer.currentPromise);
    }
    // reset the initial value of candidates exist flag to true
    this.candidatesContainer.candidatesExistFlag = true;
    // reset the page number to 1 as this is a new query
    this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
    this.currentRequisitionPage = 1;
    // clear the existing candidates
    this.candidatesContainer.candidates = [];
    this.candidatesContainer.disableInfiniteScroll = false;
    this.candidatesContainer.candidatesQueryFilter.workflowStates =
      this.candidatesContainer.candidatesQueryFilter.workflowStates.filter((state: any) => state); // remove null and undefined values

    // Hide Display Filter
    if (this.candidateFilterItemsSelected.length === 0) {
      this.displayCandidateFilterFlag = false;
      this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
    }

    if (this.candidatesContainer.currentPromise !== null) {
      // wait for the cancel promise to be fulfilled, if it was called.
      setTimeout(() => {
        this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
        this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
        if (this.isRowViewActive) {
          this.candidatesContainer.getNextPage(this.currentRequisitionPage);
        } else {
          this.candidatesContainer.getNext();
        }
      }, 200);
    } else {
      this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
      this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
      if (this.isRowViewActive) {
        this.candidatesContainer.getNextPage(this.currentRequisitionPage);
      } else {
        this.candidatesContainer.getNext();
      }
    }
  }
}
